import React from 'react'
import PropTypes from 'prop-types'
import { PortalContextConsumer } from './PortalContext'

class PortalDest extends React.PureComponent {
  static propTypes = {
    portalRegistry: PropTypes.object.isRequired,
    channel: PropTypes.string.isRequired,
    Component: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object, PropTypes.symbol]) // either React component or native HTML element (e.g. div, p, a)
  }

  static defaultProps = {
    Component: React.Fragment
  }

  constructor (props) {
    super(props)
    this.state = {
      portals: props.portalRegistry.subscribe(this.onPortalsUpdate, props.channel)
    }
  }

  onPortalsUpdate = (portals) => {
    this.setState({ portals }, () => this.forceUpdate())
  }

  render () {
    const { Component } = this.props
    const { portals } = this.state

    return (
      <Component>
        {Object.keys(portals).map((key) => {
          const portal = portals[key]
          if (!React.isValidElement(portal)) return portal
          return React.cloneElement(portal, { key })
        })}
      </Component>
    )
  }
}

export default PortalContextConsumer(PortalDest)
